import { render, staticRenderFns } from "./AccountOwner.vue?vue&type=template&id=64a4c92c&scoped=true"
import script from "./AccountOwner.vue?vue&type=script&lang=js"
export * from "./AccountOwner.vue?vue&type=script&lang=js"
import style0 from "./AccountOwner.vue?vue&type=style&index=0&id=64a4c92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4c92c",
  null
  
)

export default component.exports